/* Бутоните плюс и минус в количката.
   Формата работи и без този файл — тогава количеството се въвежда
   в полето и се натиска „Обнови“. JS-ът само праща формата вместо това. */
(function () {
  'use strict';

  function init(root) {
    var forms = (root || document).querySelectorAll('[data-lp-cart]');
    Array.prototype.forEach.call(forms, function (form) {
      if (form.dataset.lpCartOn === '1') return;
      form.dataset.lpCartOn = '1';

      form.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-lp-cart-step]');
        if (!btn) return;

        var row = btn.closest('.lp-cart__item');
        var num = row && row.querySelector('[data-lp-cart-num]');
        if (!num) return;

        var step = parseInt(btn.dataset.lpCartStep, 10);
        var next = (parseInt(num.value, 10) || 0) + step;
        if (next < 0) next = 0;

        num.value = next;
        form.submit();
      });

      // Ръчна промяна в полето също праща формата, щом полето загуби фокус.
      form.addEventListener('change', function (e) {
        if (e.target.matches('[data-lp-cart-num]')) form.submit();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
})();
